/**
 * Repeatable instance list / editor interaction vs request edit mode (#1154).
 * Mirrors {@link isRackMutationMode} in rackPermissionsInteraction.ts (#1122).
 */

/** User may mutate instance list or editor (add, dup, delete, reorder, save unit). */
export function isInstanceMutationMode(
  isEditing: boolean,
  disabled: boolean,
): boolean {
  return isEditing && !disabled;
}

/** Persisted request view mode — list rows open read-only details, mutations off. */
export function isInstanceListReadOnly(
  isDraftMode: boolean,
  isInstanceMutationModeActive: boolean,
): boolean {
  return !isDraftMode && !isInstanceMutationModeActive;
}
